import New from "csi/table/New";
import xml from "csi/xml";
import { CallMethod } from "csi/xml/CallMethod";
import declare from "dojo/_base/declare";
import lang from "dojo/_base/lang";
import Relationship from "csi/def/Relationship";
import csiStore from "csi/store/_base";
import Action from "csi/def/Action";
import ViewRef from "csi/def/ViewRef";
import StoreNamesConstructor, { StoreNames } from "csi/store/Names";

/** @property {string} FORMULATED_MATERIAL - the node type used in the controller */
const FORMULATED_MATERIAL = "FormulatedMaterial";

const NewFormulatedMaterialImpactAnalysis= declare(New, {
	/**
	 * @override
	 * Allow controller to add parameters to popup view
	 */
	onCreatePopupParams(params) {
		params.productLabel = FORMULATED_MATERIAL;
		params.productStore = this._getFormulatedMaterialStore();
	},

	/**
	 * Fetch list of all FormulatedMaterials
	 */
	_getFormulatedMaterialStore(): StoreNames {
		const rel = lang.mixin(new Relationship(), {
			m_typeNode: FORMULATED_MATERIAL,
		});

		const storeOptions = csiStore.namesOptionsByRelationship(this.getContext(), rel);
		storeOptions.data = [csiStore.nameObject("")];
		storeOptions.action = lang.mixin(new Action(), {
			m_viewRef: lang.mixin(new ViewRef(), {
				m_id: "AllFormulatedMaterials",
				m_url: "centric://REFLECTION/INSTANCE/_CS_Data/null",
			}),
		});
		return new StoreNamesConstructor(storeOptions);
	},

	/**
	* @override
	* On FormulatedMaterial node, make the FormulatedMaterial as default & selected on engineering change form
	*/
	onCreatePopup(view) {
		view.addFixedValue(FORMULATED_MATERIAL, this.m_urlParent);
		this.inherited(arguments);
	},

	/**
	 * @override
	 * FormulatedMaterial is marked to be taken care on the server side
	 */
	toWriterRequest(fd: FormData): CallMethod {
		const call = this.inherited<CallMethod>(arguments);
		const formulatedMaterialURLs = this.m_formData.getFieldValue(FORMULATED_MATERIAL, true);
		call.addParameter("AddURLs", xml.ATTR_REFLIST, formulatedMaterialURLs);
		call.addParameter("Purpose", xml.ATTR_ENUM, "ECPurpose:ImpactAnalysis");
		return call;
	},
});

export = NewFormulatedMaterialImpactAnalysis;